import axios from './axios'

export function Register(mobile, password, name, verify, invite) {
	return axios({
		url: '/register',
		method: 'post',
		data: {
			mobile,
			password,
			name,
			verify,
			invite
		}
	})
}

export function Box_detail(id) {
	return axios({
		url: '/box/detail',
		params: {
			id
		}
	})
}

export function set_inviter(invite_code) {
	return axios({
		url: 'set_inviter',
		method: 'post',
		data: {
			invite_code
		}
	})
}

export function PostEmail(email, usage) {
	return axios({
		url: '/send_email',
		method: 'post',
		data: {
			email,
			usage
		}
	})
}

export function PostSendSms(mobile, is_use) {
	return axios({
		url: '/send_sms',
		method: 'post',
		data: {
			mobile,
			is_use
		}
	})
}


export function SignIn(mobile, password, verify = '') {
	if (verify == '') {
		return axios({
			url: '/login',
			method: 'post',
			data: {
				mobile, password
			}
		})
	} else {
		return axios({
			url: '/sms_login',
			method: 'post',
			data: {
				mobile, verify
			}
		})

	}

}
export function PersonalInfo() {
	return axios({
		url: '/me'
	})
}




export function Storage(page, status) {
	return axios({
		url: '/storage',
		params: {
			page,
			status
		}
	})
}

export function Extract(data) {
	return axios({
		url: '/extract',
		method: 'post',
		data: {
			data
		}
	})
}

export function Cash(data) {
	return axios({
		url: '/cash',
		method: 'post',
		data: {
			data
		}
	})
}

export function Give(id, invite_code) {
	return axios({
		url: '/give',
		method: 'post',
		data: {
			id,
			invite_code
		}
	})
}

export function Beans() {
	return axios({
		url: '/beans'
	})
}

export function Recharge(id, pay_way) {

	return axios({
		url: '/recharge',
		method: 'post',
		data: {
			id,
			pay_way
		}
	})
}

export function Recharge_record(page) {
	return axios({
		url: '/recharge_record',
		params: {
			page
		}
	})
}

export function BeansDetail(code) {
	return axios({
		url: '/bean/detail',
		params: {
			code
		}
	})
}


export function RoomSave(name, end_time, people_number, box_record_ids, describe, password, min_recharge, me_inviter) {
	return axios({
		url: 'room/save',
		method: 'post',
		data: {
			name,
			end_time,
			people_number,
			box_record_ids,
			describe,
			password,
			min_recharge,
			me_inviter
		}
	})
}
export function Promote() {
	return axios({
		url: '/promote'
	})
}

export function Be_inviter(page) {
	return axios({
		url: '/be_inviter',
		params: {
			page
		}
	})
}

export function UnpackingRecord(id) {
	return axios({
		url: '/openhistory',
		params: {
			id
		}
	})
}

export function GetHotBox() {
	return axios({
		url: '/hotbox'
	})
}


export function Rooms(page, status) {
	return axios({
		url: '/rooms',
		params: {
			page,
			status
		}
	})
}

export function RoomDetail(id) {
	return axios({
		url: '/room/detail',
		params: {
			id
		}
	})
}

export function RoomJoin(id, password) {
	return axios({
		url: '/room/join',
		method: 'post',
		data: {
			id,
			password
		}
	})
}


export function UserRooms(page) {
	return axios({
		url: '/user/rooms',
		params: {
			page
		}
	})
}

export function BeansFirst() {
	return axios({
		url: '/beans/first'
	})
}
export function BeansTotal() {
	return axios({
		url: '/beans/total'
	})
}
export function Set_invite_code(code) {
	return axios({
		url: '/set_invite_code',
		method: 'post',
		data: {
			code
		}
	})
}

export function Set_avatar(path) {
	return axios({
		url: '/set_avatar',
		method: 'post',
		data: {
			path
		}
	})
}

export function luckyType() {
	return axios({
		url: '/lucky/type'
	})
}

export function luckyList(type_id) {
	return axios({
		url: 'lucky/list',
		params: {
			type_id
		}
	})
}
export function luckySo(name) {
	return axios({
		url: '/lucky/so',
		params: {
			name
		}
	})
}



export function base64(data){
	return axios({
		url: '/image/base64',
		method: 'post',
		data: {
			data
		}
	})
}


export function Reset_password(mobile, password, verify) {
	return axios({
		url: '/reset_password',
		method: 'post',
		data: {
			mobile,
			password,
			verify
		}
	})
}

export function Info() {
	return axios({
		url: '/info'
	})
}

export function Blind_box_channel(client_id) {
	// return axios({
	// 	url: '/arena/join-channel',
	// 	method: 'post',
	// 	data: {
	// 		client_id
	// 	}
	// })
}

export function Card_recharge(card) {
	return axios({
		url: '/card-recharge',
		method: 'post',
		data: {
			card
		}
	})
}

export function Set_Name(name) {
	return axios({
		url: '/set_name',
		method: 'post',
		data: {
			name
		}
	})
}

export function Arena_Create(user_num, box, arena_type) {
	return axios({
		url: '/arena/create',
		method: 'post',
		data: {
			user_num,
			box,
            arena_type,
		}
	})
}

export function Arena_Box_List() {
	// return axios({
	// 	url: '/arena/box-list',
	// })
}

///邀请机器人
export function Arena_Robots(game_arena_id, seat) {
	return axios({
		url: '/arena/invite-robots',
		method: 'post',
		data: {
			game_arena_id,
			seat
		}
	})
}

///排行
export function Arena_Rank() {
	return axios({
		url: '/arena/rank',
	})
}

export function Arena_List(page) {
	return axios({
		url: '/arena/list',
		params: {
			page
		}
	})
}

export function Arena_Detail(game_arena_id) {
	return axios({
		url: '/arena/detail',
		params: {
			game_arena_id
		}
	})
}

export function Arena_Recover(data) {
	return axios({
		url: '/arena/recovery',
		method: 'post',
		data: {
			data
		}
	})
}


export function Arena_Join(game_arena_id, seat) {
	return axios({
		url: '/arena/join',
		method: 'post',
		data: {
			game_arena_id,
			seat
		}
	})
}

export function Arena_History(page) {
	return axios({
		url: '/arena/history',
		params: {
			page
		}
	})
}

export function Arena_Me_History(page) {
	return axios({
		url: '/arena/me-history',
		params: {
			page
		}
	})
}

export function Snatch(page, status) {
	return axios({
		url: '/snatch',
		params: {
			page,
			status
		}
	})
}

export function Snatch_Join(id, num) {
	return axios({
		url: '/snatch/join',
		method: 'post',
		data: {
			id,
			num
		}
	})
}

export function Snatch_Detail(id) {
	return axios({
		url: '/snatch/detail',
		params: {
			id
		}
	})
}

export function GetShop(min_integral, max_integral, sort, page) {
	return axios({
		url: '/shop',
		params: {
			min_integral,
			max_integral,
			sort,
			page
		}
	})
}

export function Shop_Buy(id, num) {
	return axios({
		url: '/shop/exchange',
		method: 'post',
		data: {
			id,
			num
		}
	})
}

export function Welfare() {
	return axios({
		url: '/welfare'
	})
}


export function WelfareOpen(id, cdk) {
	return axios({
		url: '/welfare/open',
		method: 'post',
		data: {
			id,
			cdk
		}
	})
}

export function AwardGet(id) {
	return axios({
		url: '/award/get',
		params: {
			id
		}
	})
}


///vip奖励领取
export function VipAward(level) {
	return axios({
		url: '/vip_award',
		method: 'post',
		data: {
			level
		}
	})
}

///vip奖励领取记录
export function VipAwardInfo() {
	return axios({
		url: '/vip_award_info',
		//method: 'post',
		data: {
		}
	})
}



export function LuckyOpen(id, percent) {
	return axios({
		url: '/lucky/open',
		method: 'post',
		data: {
			id,
			percent
		}
	})
}

export function cash(data) {
	return axios({
		url: '/cash',
		method: 'post',
		data: {
			data
		}
	})
}
export function BoxDetail(id) {
	return axios({
		url: '/box/detail',
		params: {
			id
		}
	})
}

export function Open(id, num) {
	return axios({
		url: '/open',
		method: 'post',
		data: {
			id,
			num
		}
	})
}

export function Red(id, num) {
	return axios({
		url: '/red'
	})
}

export function RedOpen(type, id, key) {
	return axios({
		url: '/red/open',
		method: 'post',
		data: {
			type,
			id,
			key
		}
	})
}

export function AGive(data, invite_code) {
	return axios({
		url: '/give',
		method: 'post',
		data: {
			data,
			invite_code
		}
	})
}

export function Synthesis(data, out_id) {
	return axios({
		url: '/synthesis',
		method: 'post',
		data: {
			data,
			out_id
		}
	})
}

export function Synthesis_list(page) {
	return axios({
		url: '/synthesis/list',
		params: {
			page
		}
	})
}


export function SteamUrl(steam_url) {
	return axios({
		url: '/set_steam_url',
		method: 'post',
		data: {
			steam_url
		}
	})
}

export function CountInfo() {
	return axios({
		url: '/count_info'
	})
}


///签到活动数据
export function ActSignin() {
	return axios({
		url: '/act_signin'
	})
}
//签到
export function SetSignin(week) {
	return axios({
		url: '/act_signin_set',
		method: 'post',
		data: {
			week
		}
	})
}
//兑换签到活动奖励
export function SigninAward(award_id) {
	return axios({
		url: '/act_signin_award',
		method: 'post',
		data: {
			award_id
		}
	})
}

//消费活动数据
export function ActConsume() {
	return axios({
		url: '/act_consume'
	})
}
//消费活动奖励领取
export function ConsumeAward(award_id) {
	return axios({
		url: '/act_consume_award',
		method: 'post',
		data: {
			award_id
		}
	})
}
//新人奖励
export function GetNovice() {
	return axios({
		url: '/act_novice'
	})
}

//领取新人奖励
export function GetNoviceAward(award_id) {
	return axios({
		url: '/act_novice_award',
		method: 'post',
		data: {
			award_id
		}
	})
}

///实名认证
export function Identification(name, cardid){
    return axios({
		url: '/real_name',
		method: 'post',
		data: {
			name,
            cardid
		}
	})
}

///排雷
export function BombInfo(){
    return axios({
		url: '/bomb_info'
	})
}
///排雷刷新
export function RandomPrice(interval){
     return axios({
		url: '/random_price',
		method: 'post',
		data: {
			interval
		}
	})
    
}

///排雷
export function StartBomb(){
    return axios({
		url: '/start_bomb',
		method: 'post',
		data: {
		}
	})
}
///排雷
export function OpenBomb(layer, cell){
    return axios({
		url: '/open_bomb',
		method: 'post',
		data: {
			layer,
			cell
		}
	})
}

///领取奖励  
export function GetBombAward(type){
	return axios({
		url: '/bomb_award',
		method: 'post',
		data: {
			type,///1:领取饰品 2:饰品换成金币
		}
	})
}
